module.exports = __webpack_public_path__ + "img/p34.d55aa521.png";